<template>
  <div class="featured ">
    <!-- <div class="eye-visual">
      <img src="@/assets/ear.png" />
    </div> -->
      <a class="featured-link" target="_blank" href="https://www.nporadio1.nl/podcasts/het-escortbedrog">
        <div class="featured-content">
          <div class="featured-image">
            <img :src="`${assetsUrl}${featured.image.data.attributes.url}`" alt="" />
          </div>
          <div>
            <div class="featured-title" v-html="featured['title']"></div>
            <!-- <div class="featured-subtitle">{{  featured['subtitle'] }}</div> -->
          </div>
        </div>
        <p class="featured-teaser">{{ featured['teaser'] }}</p>
      </a>
  </div>
</template>
 
<script>
// import "./articlelist.scss";
import { mapGetters } from "vuex";
export default {
  name: "featured",

  data() {
    return {
        assetsUrl: process.env.VUE_APP_ASSETS,
    }
  },

  computed: {
    ...mapGetters(["featured"])
  },
};
</script>

<style lang="scss">
  .knd-flex {
    display: flex;
  }

  .featured {
    background: linear-gradient(153.73deg, #4D00FF 14.42%, #28006D 94.3%);
    border-radius: 12px;
    padding: 2rem;
    position: relative;
    cursor: pointer;

    .featured-content {
      display: flex;
    }

    a {
      text-decoration: none;

      &:hover {
        color: inherit;
      }
    }
    .featured-image {
      // display: none;
      height: 110px;
      width: 110px;
      flex-shrink: 0;
      padding-right: 10px;
      @include md { 
        display: block;
        }


    }

    .featured-title {
      font-family: $font-header;
      font-size: 3rem;
      line-height: 3.2rem;
      font-weight: 200;
      p {
        margin-bottom: 0;
      }

      strong {
        font-weight: 400;
      }
    }

    .featured-subtitle {
      font-family: $font-header;
      color: #00D9AD;
    }

    .featured-teaser {
      font-size: 16px;
      margin-bottom: 0;
    }
  }

  .eye-visual {
        width: auto;
        height: 38px;
        width: 60px;
        position: absolute;
        right: 20px;
        top: -20px;
        z-index: 2;

        @media (max-width: 768px) {
            bottom: 10px;
            right: 10px;
        }
    }

</style>